export default {
  newVersionOf: 'Nova versão de',
  versionNotes: 'Notas da versão',
  versionNotesPlaceholder: 'ex. Mais um ano de dados adicionado à versão anterior',
  noPreviousVersion: 'Deixe o campo vazio se este modelo não tiver uma versão anterior',
  willBeVersion: 'Este modelo será a v{version} de {name}',
  isVersion: 'Este modelo é a v{version}. Limpe o campo para desvinculá-lo',
  notLatest: 'Este modelo é a v{version}. Só a última versão de uma família pode ser desvinculada',
  hasOwnVersions: 'Este modelo é a primeira versão da sua própria família, então não pode ser versão de outro modelo'
}
